// src/components/MarketingConsentCheckbox.js
//
// Extracted from AdvisorConnectForm.js's inline checkbox — same markup,
// same copy, same className, just lifted so any other contact-collecting
// form (a future EmailCaptureScreen checkbox, anything else that asks for
// an email) can reuse it instead of hand-rolling its own copy of this
// checkbox. Canonical copy lives here, once — see MARKETING_CONSENT_TEXT.
// If this wording ever changes, update it here and nowhere else; every
// caller picks up the change automatically.
//
// Deliberately a dumb controlled input — checked/onChange only. No fetch
// logic, no knowledge of consent_events or which edge function eventually
// records this. Recording the resulting value is the caller's job (see
// advisor-connect/index.ts and the client-side equivalent still to be
// consolidated for AuthCallback.js's path).

import React from 'react'

// export const MARKETING_CONSENT_TEXT = 'Send me occasional HolaSam tax tips and updates (optional)'
export const MARKETING_CONSENT_TEXT = 'John (creator of HolaSam) can contact me for feedback and to share updates. No spam!'

export default function MarketingConsentCheckbox({ checked, onChange }) {
  return (
    <label className="tr-consent-checkbox">
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} />
      <span>{MARKETING_CONSENT_TEXT}</span>
    </label>
  )
}
